import { useEffect, useRef } from "react";

export const usePrevious = <T>(value: T): T => {
    let ref = useRef<T>(value);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
